import { DateTime, Maybe } from '../../common/types'

export interface AutomobileAndTouringClubFinland {
  jobId: string
  caseNumber: string
  serviceChannel: string
  billingInfo: string
  personCount: number
  vehicleMileage: number
  arcCodes: ArcCodes
  repairShopId: string
  distanceTowed: number
  towingInsistedByCustomer: boolean
  delayedTowing: boolean
  delayedTowingReason: string
  jobTimestamps: JobTimestamps
  situationDescription: string
  batteryService: BatteryService
}

/** Only Autoliitto can set this code */
export const INVALID_ARC_DESCRIPTION_CODE = 46

interface ArcCodeList {
  code: string
  type: string
  fault_codes: Array<number>
}
export interface ArcCodeLists {
  components: ArcCodeList[]
  descriptions: Omit<ArcCodeList, "fault_codes">[]
  completions: Omit<ArcCodeList, "fault_codes">[]
}


export interface ArcCodesFile {
  components: ComponentArcCodeFile[]
  descriptions: DescriptionArcCodeFile[]
  completions: CompletionArcCodeFile[]
}

export interface BatteryService {
  deliveredBattery: Maybe<string>
  paymentType: Maybe<string>
  battery: Maybe<string>
}

interface ComponentArcCodeFile {
  code: string
  translation: string
  description: string
  category: string
  type: string
}

interface DescriptionArcCodeFile {
  code: string
  description: string
  translation: string
  type: string
}

interface CompletionArcCodeFile {
  code: string
  user: string
  status: string
  description: string
  type: string
}

interface ArcCode {
  code: Maybe<string>
  label: Maybe<string>
}

export interface ArcCodes {
  component: ArcCode
  description: ArcCode
  completion: ArcCode
}

export interface JobTimestamps {
  estimatedTimeOfArrival: Maybe<DateTime>
  actualTimeOfArrival: Maybe<DateTime>
  estimatedTimeOfCompletion: Maybe<DateTime>
  actualTimeOfCompletion: Maybe<DateTime>
}
